export class Integrador {
    
  id
  nome
  created_at
  updated_at
  deleted_at
  url
  token

  constructor (obj = {id: null, nome: null, created_at: null, updated_at: null, deleted_at: null, url: null, token: null}) {
    this.id = obj.id 
    this.nome = obj.nome 
    this.created_at = obj.created_at 
    this.updated_at = obj.updated_at 
    this.deleted_at = obj.deleted_at 
    this.url = obj.url 
    this.token = obj.token 
  }
  
}


// WEBPACK FOOTER //
// ./src/views/IntegradoresApi/_models/IntegradorModel.js